<script lang="ts">
    import type { DialogFieldCustom } from "ceyper-common";
    import type { DownloadAsOptionsValue } from "$lib/dialog/downloadAsOptions";

    export let field: DialogFieldCustom;

    const value = field.value as DownloadAsOptionsValue;
</script>

<!----------------------------------------------------------------------------->

<div class="download-options">
    <label>
        <span>Name</span>
        <input type="text" bind:value={value.name} />
    </label>

    <label>
        <span>Format</span>
        <select bind:value={value.format}>
            <option value="png">PNG</option>
            <option value="gif">GIF</option>
        </select>
    </label>

    <label>
        <span>Scale</span>
        <input type="number" min="1" max="1024" step="1" bind:value={value.scale} />
    </label>

    {#if value.format === "png"}
        <label class="checkbox">
            <span>Download all frames</span>
            <input type="checkbox" bind:checked={value.allFrames} />
        </label>
    {:else}
        <label class="checkbox">
            <span>Loop GIF</span>
            <input type="checkbox" bind:checked={value.gifLoop} />
        </label>

        <h3 class="advanced">Advanced</h3>

        <label>
            <span>Loop count</span>
            <input type="number" min="0" max="1000" step="1" bind:value={value.gifLoopCount} />
        </label>

        <label>
            <span>Alpha</span>
            <select bind:value={value.gifAlphaMode}>
                <option value="transparent-threshold">Transparent threshold</option>
                <option value="matte-color">Matte color</option>
            </select>
        </label>

        {#if value.gifAlphaMode === "transparent-threshold"}
            <label>
                <span>Alpha threshold</span>
                <input type="number" min="0" max="255" step="1" bind:value={value.gifAlphaThreshold} />
            </label>
        {:else}
            <label>
                <span>Matte color</span>
                <div class="color-row">
                    <input type="color" bind:value={value.gifMatteColor} />
                    <input type="text" bind:value={value.gifMatteColor} />
                </div>
            </label>
        {/if}

        <label class="checkbox">
            <span>Dither GIF</span>
            <input type="checkbox" bind:checked={value.gifDither} />
        </label>

        <label>
            <span>GIF quality</span>
            <select bind:value={value.gifQuality}>
                <option value="fast">Fast</option>
                <option value="balanced">Balanced</option>
                <option value="best">Best</option>
            </select>
        </label>
    {/if}
</div>

<!----------------------------------------------------------------------------->

<style>
    .download-options {
        grid-column: span 2;
        display: grid;
        grid-template-columns: max-content 1fr;
        gap: 0.5rem;
        align-items: center;
    }

    label {
        display: grid;
        grid-template-columns: subgrid;
        grid-column: span 2;
        align-items: center;
    }

    .checkbox {
        grid-template-columns: 1fr max-content;
    }

    span {
        margin-right: 0.5rem;
    }

    .advanced {
        all: unset;
        grid-column: span 2;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-top: 0.5rem;
        color: var(--t400);
        cursor: pointer;
    }

    input[type="number"] {
        width: 8ch;
    }

    .color-row {
        display: flex;
        align-items: center;
        gap: 0.5rem;
    }

    .color-row input[type="text"] {
        width: 12ch;
    }
</style>
